import axios from "axios";
import {useParams} from 'react-router-dom';
import {useEffect, useState} from "react";
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function IpPackPay() {
    const [ippackData, setippackData] = useState([]);
    const [amount, setAmount] = useState(0);
    const [balance, setBalance] = useState(0);
    const [mapData, setMapData] = useState([]);
    const [iptotData, setIptotData] = useState([]);
    const {packid} = useParams();
    const [trans, setTrans] = useState('');
    useEffect(() => {
        try {
            axios.get(baseUrl + 'ippack-pay/' + packid)
                .then(function (response) {
                    setippackData(response.data);
                    setAmount(response.data[0].pack_tot);
                    setBalance(0);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        if (ippackData.length > 0) {
            const pid = ippackData[0]?.pack_price?.pack;
            const iid = ippackData[0]?.pack_price?.insur;
            const ip_id = ippackData[0]?.ip?.id;
            axios.get(`${baseUrl}view-pack-map/${pid}/${iid}`)
                .then(response => {
                    setMapData(response.data);
                })
                .catch(error => {
                    console.log("Error fetching pack map:", error);
                });
            axios.get(`${baseUrl}view-ip-tot/${ip_id}`)
                .then(response => {
                    setIptotData([response.data]);
                })
                .catch(error => {
                    console.log("Error fetching pack map:", error);
                });
        }
    }, [ippackData]); // runs only after oppackData is populated
    const handleAmountChange = (event) => {
        let newAmount = parseInt(event.target.value, 10);
        const maxAmount = ippackData[0].pack_tot;
        if (newAmount > maxAmount) {
            newAmount = maxAmount;
        }
        setAmount(newAmount);
        setBalance(maxAmount - newAmount);
    };
    const handlePaymentTypeChange = (event) => {
        const value = event.target.value;
        if (value === 'creditpay') {
            setAmount(0);
            setBalance(ippackData[0].pack_tot);
        } else {
            setAmount(ippackData[0].pack_tot);
            setBalance(0);
        }
    }
    const handleFormSubmit = (e) => {
        e.preventDefault();
        const dbType = document.getElementById('dbType').value;
        const packid = ippackData[0]?.id;
        const amount = ippackData[0]?.pack_tot || 0;
        const balance = 0;
        const patId = ippackData[0]?.ip?.pat?.id || "";
        const consId = ippackData[0]?.cons?.id || "";
        // Step 1: Get Sale IP Pack invoice
        axios.post(`${baseUrl}get_sale_ippack/`)
            .then(response => {
                const sale_ippack = response.data.value;
                // ---------------- IP PACK PAYMENT ----------------
                const _formDataPack = new FormData();
                _formDataPack.append('pack_paid', amount);
                _formDataPack.append('pack_balance', balance);
                _formDataPack.append('pack_invoice', sale_ippack);
                _formDataPack.append('pack_price', ippackData[0]?.pack_price?.id);
                _formDataPack.append('pack_pmode', dbType);
                _formDataPack.append('trans_detail', trans);
                _formDataPack.append('cashier', userName);
                _formDataPack.append('pack_status', '2');
                _formDataPack.append('addedby', ippackData[0]?.addedby);
                _formDataPack.append('ip_add', ipAddress);
                _formDataPack.append('location', userLocation);
                axios.post(`${baseUrl}ippack-payment/${packid}/`, _formDataPack, {
                    headers: {'content-type': 'multipart/form-data'}
                })
                    .then(presponse => {
                        if (presponse.status !== 200 && presponse.status !== 201) return;
                        // ---------------- LAB BLOCK ----------------
                        const labRows = mapData.filter(r => r.lab);
                        if (labRows.length) {
                            axios.post(`${baseUrl}get_appt_lab_number/`)
                                .then(resp => {
                                    const appt_lab = resp.data.value;
                                    const _formDataLab = new FormData();
                                    const labIds = labRows.map(r => r.lab).join(',');
                                    const labTests = labRows.map(r => r.lab_test).join(',');
                                    const labAmounts = labRows.map(r => r.labamount).join(',');
                                    const labTotal = labRows.reduce((sum, r) => {
                                        return sum + r.labamount.split(',').reduce((a, b) => a + (parseFloat(b) || 0), 0);
                                    }, 0).toFixed(2);
                                    _formDataLab.append('appt_id', appt_lab);
                                    _formDataLab.append('pat', ippackData.map(r => r.ip.pat).join(','));
                                    _formDataLab.append('ip', ippackData.map(r => r.ip.id).join(','));
                                    _formDataLab.append('cons', consId);
                                    _formDataLab.append('lab_id', appt_lab);
                                    _formDataLab.append('ltest_id', labIds);
                                    _formDataLab.append('lab_test', labTests);
                                    _formDataLab.append('lab_amount', labAmounts);
                                    _formDataLab.append('lab_tot', labTotal);
                                    _formDataLab.append('lab_status', '1');
                                    _formDataLab.append('addedby', userName);
                                    _formDataLab.append('ip_add', ipAddress);
                                    _formDataLab.append('location', userLocation);
                                    axios.post(`${baseUrl}ip-lab-create/`, _formDataLab)
                                        .then(lresponse => {
                                            const appt_id = lresponse.data.appt_id;
                                            // ---------------- LAB PAYMENT ----------------
                                            axios.post(`${baseUrl}get_sale_lab/`).then(sres => {
                                                const sale_lab = sres.data.value;
                                                const _formDataLabPay = new FormData();
                                                _formDataLabPay.append('lab_paid', labTotal);
                                                _formDataLabPay.append('lab_balance', 0);
                                                _formDataLabPay.append('lab_invoice', sale_lab);
                                                _formDataLabPay.append('lab_pmode', dbType);
                                                _formDataLabPay.append('cashier', userName);
                                                _formDataLabPay.append('lab_status', '2');
                                                axios.post(`${baseUrl}ip-lab-payment/${appt_id}/`, _formDataLabPay, {
                                                    headers: {'content-type': 'multipart/form-data'}
                                                }).then(lpresponse => {
                                                    if (dbType === 'advance') updateIpTot(parseFloat(labTotal), balance);
                                                }).catch(console.log);
                                            }).catch(console.log);
                                        }).catch(console.log);
                                }).catch(console.log);
                        }
                        // ---------------- INVOICE BLOCK ----------------
                        const invRows = mapData.filter(r => r.inv);
                        if (invRows.length) {
                            axios.post(`${baseUrl}get_appt_inv_number/`).then(resp => {
                                const appt_inv = resp.data.value;
                                const _formDataInv = new FormData();
                                const invIds = invRows.map(r => r.inv).join(',');
                                const invTests = invRows.map(r => r.inv_test).join(',');
                                const invAmounts = invRows.map(r => r.invamount).join(',');
                                const invTotal = invRows.reduce((sum, r) => sum + r.invamount.split(',').reduce((a, b) => a + (parseFloat(b) || 0), 0), 0).toFixed(2);
                                _formDataInv.append('appt_id', appt_inv);
                                _formDataInv.append('pat', ippackData.map(r => r.ip.pat).join(','));
                                _formDataInv.append('ip', ippackData.map(r => r.ip.id).join(','));
                                _formDataInv.append('cons', consId);
                                _formDataInv.append('inv_id', appt_inv);
                                _formDataInv.append('itest_id', invIds);
                                _formDataInv.append('inv_test', invTests);
                                _formDataInv.append('inv_amount', invAmounts);
                                _formDataInv.append('inv_tot', invTotal);
                                _formDataInv.append('inv_status', '1');
                                _formDataInv.append('addedby', userName);
                                _formDataInv.append('ip_add', ipAddress);
                                _formDataInv.append('location', userLocation);
                                axios.post(`${baseUrl}ip-inv-create/`, _formDataInv).then(iresponse => {
                                    const appt_id = iresponse.data.appt_id;
                                    axios.post(`${baseUrl}get_sale_inv/`).then(ivres => {
                                        const sale_inv = ivres.data.value;
                                        const _formDataInvPay = new FormData();
                                        _formDataInvPay.append('inv_paid', invTotal);
                                        _formDataInvPay.append('inv_balance', 0);
                                        _formDataInvPay.append('inv_invoice', sale_inv);
                                        _formDataInvPay.append('inv_pmode', dbType);
                                        _formDataInvPay.append('cashier', userName);
                                        _formDataInvPay.append('inv_status', '2');
                                        axios.post(`${baseUrl}ip-inv-payment/${appt_id}/`, _formDataInvPay, {
                                            headers: {'content-type': 'multipart/form-data'}
                                        }).then(ipresponse => {
                                            if (dbType === 'advance') updateIpTot(parseFloat(invTotal), balance);
                                        }).catch(console.log);
                                    }).catch(console.log);
                                }).catch(console.log);
                            }).catch(console.log);
                        }
                        // ---------------- MINOR PROCEDURE BLOCK ----------------
                        const minRows = mapData.filter(r => r.min);
                        if (minRows.length) {
                            axios.post(`${baseUrl}get_appt_min_number/`)
                                .then(resp => {
                                    const appt_min = resp.data.value;
                                    const minIds = minRows.map(r => r.min).join(',');
                                    const minTests = minRows.map(r => r.min_test).join(',');
                                    const minUnits = minRows
                                        .map(r => r.minamount.split(',').map(_ => 1)) // create 1 for each amount
                                        .flat();
                                    const minAmounts = minRows
                                        .map(r => r.minamount.split(',').map(a => parseFloat(a.trim()) || 0)) // split each value
                                        .flat(); // flatten array of arrays into a single array
                                    const minTotal = minAmounts.reduce((a, b) => a + b, 0).toFixed(2);
                                    const _formDataMin = new FormData();
                                    _formDataMin.append('appt_id', appt_min);
                                    _formDataMin.append('pat', ippackData.map(r => r.ip.pat).join(',')); // Keep as you want
                                    _formDataMin.append('ip', ippackData.map(r => r.ip.id).join(','));
                                    _formDataMin.append('cons', consId);
                                    _formDataMin.append('min_id', minIds);
                                    _formDataMin.append('min_test', minTests);
                                    _formDataMin.append('min_amount', minAmounts.join(',')); // CSV string of amounts
                                    _formDataMin.append('min_units', minUnits.join(','));   // CSV string of units
                                    _formDataMin.append('min_tot', minTotal);
                                    _formDataMin.append('min_status', '1');
                                    _formDataMin.append('addedby', userName);
                                    _formDataMin.append('ip_add', ipAddress);
                                    _formDataMin.append('location', userLocation);
                                    axios.post(`${baseUrl}ip-min-create/`, _formDataMin)
                                        .then(res => console.log('Minor procedures saved', res.data))
                                        .catch(console.log);
                                })
                                .catch(console.log);
                        }
                        // ---------------- SURGERY BLOCK ----------------
                        const surgRows = mapData.filter(r => r.surgery);
                        if (surgRows.length) {
                            const _formDataSurg = new FormData();
                            _formDataSurg.append('ip', ippackData.map(r => r.ip.id).join(','));
                            _formDataSurg.append('ot_type', surgRows.map(r => r.surgery).join(','));
                            _formDataSurg.append('status', '1');
                            _formDataSurg.append('addedby', userName);
                            _formDataSurg.append('ip_add', ipAddress);
                            _formDataSurg.append('location', userLocation);
                            axios.post(`${baseUrl}surgery-create/`, _formDataSurg).catch(console.log);
                        }
                        Swal.fire({
                            title: 'Payment Success and invoice is Generated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setTimeout(() => window.location.href = `/pack-invoice-ip/${sale_ippack}/`, 2000);
                    }).catch(console.log);
            }).catch(console.log);
    };
// ---------------- UTILITY: UPDATE IP TOT ----------------
    function updateIpTot(amountPaid, balance) {
        const IpId = iptotData[0][0].id;
        const _updateForm = new FormData();
        _updateForm.append('tot_invoiced', (parseFloat(iptotData[0][0].tot_invoiced) + amountPaid).toFixed(2));
        _updateForm.append('tot_paid', (parseFloat(iptotData[0][0].tot_paid) + amountPaid).toFixed(2));
        _updateForm.append('tot_balance', (parseFloat(iptotData[0][0].tot_balance) + balance).toFixed(2));
        _updateForm.append('remain_balance', (parseFloat(iptotData[0][0].remain_balance) - amountPaid).toFixed(2));
        _updateForm.append('tot_used', (parseFloat(iptotData[0][0].tot_used) + amountPaid).toFixed(2));
        _updateForm.append('addedby', userName);
        _updateForm.append('ip_add', ipAddress);
        _updateForm.append('location', userLocation);
        axios.put(`${baseUrl}update-ip-tot/${IpId}/`, _updateForm).catch(console.log);
    }
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className="row">
                        <h3 className="text-center"> IP Package Payment</h3>
                        <div className="table-responsive">
                            <table className="erp-table-modern">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th>Pack Id</th>
                                    <th>Patient IP Id</th>
                                    <th>Addedby</th>
                                    <th>Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                {ippackData.map((row, index) =>
                                    <tr style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        <td>{row.pack_price.id}</td>
                                        <td>{row.ip.ip_id}</td>
                                        <td>{row.addedby}</td>
                                        <td>{row.pack_tot}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-center">
                                <form style={{width: '500px'}}>
                                    <label>Choose Payment Type</label>
                                    <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                                        <option value="advance">From Advance</option>
                                        <option value="cash">Cash</option>
                                        <option value="card">Card</option>
                                        <option value="creditpay">Credit Payment</option>
                                        <option value="UPI">UPI</option>
                                    </select>
                                    <div className="form-group mt-3">
                                        <label style={{fontWeight: 'bold'}}>Amount: &nbsp;</label>
                                        <div className="input-group">
                                            <div className="input-group-addon me-2 ">&#8377;</div>
                                            <input type="number" name="amount" id="amount" value={amount}
                                                   onChange={handleAmountChange} max={amount}/>
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <label style={{fontWeight: 'bold'}}>Balance Amount: &nbsp;</label>
                                        <div className="input-group">
                                            <div className="input-group-addon me-2 ">&#8377;</div>
                                            <input type="number" name="balance" id="balance" value={balance}
                                                   onChange={handleAmountChange} readOnly/>
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <label style={{fontWeight: 'bold'}}>Reason: &nbsp;</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                name="trans"
                                                id="trans"
                                                value={trans}
                                                onChange={(e) => setTrans(e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default IpPackPay;